import { render, staticRenderFns } from "./vl-calendar.vue?vue&type=template&id=061e85e0"
import script from "./vl-calendar.vue?vue&type=script&lang=js"
export * from "./vl-calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports